export const formatTime24h = (timestamp: string, includeDate: boolean = false): string => {
    try {
        const date = new Date(timestamp);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        if (includeDate) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${day}-${month}-${year} at ${hours}:${minutes}`;
        }
        return `${hours}:${minutes}`;
    } catch (error) {
        console.error("Invalid timestamp format:", error);
        return "";
    }
};